import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar as AppBarComponent,
  Toolbar,
  IconButton,
  Link,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import settings from './settings';
import {
  BrandLogoFull as BrandLogoFullIcon,
  BrandLogo as BrandLogoIcon,
} from './Brand';
// import BrokerLogin from './BrokerLoginKey';
import InstructionsHighlight from './InstructionsHighlight';
import AccountMenu from './AccountMenu';
import FlagIcon from './FlagIcon';
import SupportButton from './SupportButton';
import { useHistory, useLocation } from 'react-router-dom';
import LiveUderlyingSpot from './LiveUderlyingSpot';
import {
  underlyingFoldLargeSize,
  underlyingFoldSize,
} from '../data/underlying-fold-size';
import { isShowIndianFlag } from '../special-params';
import DiwaliDiya from './DiwaliDiya';
import MiniBrokerLoginKey from '../partials/Brokers/MiniBrokerLoginKey/MiniBrokerLoginKey';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .instructions-text': {
      display: 'none',

      [theme.breakpoints.up('md')]: {
        display: 'block',
        marginRight: 7,
      },
    },

    '& .MuiToolbar-gutters': {
      paddingLeft: 10,
      paddingRight: 10,
      [theme.breakpoints.up('md')]: {
        paddingLeft: 10,
        paddingRight: 10,
      },
    },

    '& .top-bar-underlying': {
      marginLeft: 15,
      marginRight: 0,
      display: 'none',

      // eslint-disable-next-line no-useless-computed-key
      [`@media (min-width: ${underlyingFoldLargeSize}px)`]: {
        marginLeft: 25,
      },

      // eslint-disable-next-line no-useless-computed-key
      [`@media (min-width: ${underlyingFoldSize}px)`]: {
        display: 'flex',
      },
    },
  },
  appBar: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${settings.drawerWidth}px)`,
      marginLeft: settings.drawerWidth,
    },
    zIndex: 2000,
  },
  brandFull: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      marginLeft: 5,
      display: 'inline-flex',
      padding: '8px 0',
    },
  },
  brand: {
    display: 'inline-flex',
    marginRight: theme.spacing(2),
    padding: '8px 0',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  menuButton: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  search: {
    flex: 1,
    '& > div': {
      borderRadius: 5,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 90,
      maxWidth: 555,
    },
  },
  rightMenu: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  statusListeners: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'inline-flex',
      marginRight: theme.spacing(1),
      alignItems: 'center',
    },
  },
  leftMenu: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
  },
  HomeLink: {},
}));

const HomeLink = ({ children = '', className = '' }) => {
  const classes = useStyles();
  const history = useHistory();

  const onClick = (e) => {
    e.preventDefault();
    history.push('/algos');
  };

  return (
    <Link
      className={`${classes.HomeLink} ${className}`}
      href="#"
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

const AppBar = ({ handleDrawerToggle, authLogout, user, isMasterLayout }) => {
  const classes = useStyles();
  const { pathname = '' } = useLocation() || {};
  const isAlgoAndRelatedPage = pathname.includes('/algos');

  return (
    <AppBarComponent
      position="fixed"
      color="inherit"
      className={classes.root}
      id="app-bar-main"
    >
      <Toolbar>
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          className={classes.menuButton}
          color="primary"
        >
          <MenuIcon />
        </IconButton>
        <HomeLink className={classes.brandFull}>
          <BrandLogoFullIcon />
        </HomeLink>
        <HomeLink className={classes.brand}>
          <BrandLogoIcon />
        </HomeLink>

        <DiwaliDiya />

        {isShowIndianFlag && <FlagIcon />}

        {isAlgoAndRelatedPage && (
          <LiveUderlyingSpot className="top-bar-underlying" />
        )}

        {isMasterLayout ? (
          <>
            <div className={classes.rightMenu}>
              <MiniBrokerLoginKey />
              <SupportButton topBar />
              <InstructionsHighlight topBar />
              {/* <BrokerLogin /> */}
              <AccountMenu authLogout={authLogout} user={user} />
            </div>
          </>
        ) : null}
      </Toolbar>
    </AppBarComponent>
  );
};

AppBar.defaultProps = {
  user: {},
  handleDrawerToggle: () => {},
  authLogout: () => {},
  isMasterLayout: false,
};

AppBar.propTypes = {
  handleDrawerToggle: PropTypes.func,
  authLogout: PropTypes.func,
  user: PropTypes.shape({}),
  isMasterLayout: PropTypes.bool,
};

export default AppBar;
